import React, { useEffect, useState } from 'react';
import ParentContentCard from '../../common/ParentContentCard';
import { fetchData, handelDelete } from './figma.util';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import {handelDeleteFigmaHtml} from './figma.util';

const FigmaHtmlTable = ({
  projectId,
  version,
  figmaLink,
  deleteFigmaToHtmlData,
  fetchFigmaToHtmlData,
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData(projectId, version, figmaLink, setData, fetchFigmaToHtmlData);
  }, [figmaLink]);

  return (
    <ParentContentCard title="Figma Frames of Generated Code" icon="section">
      <span
        title="Reload Pages"
        className="gjs-pn-btn"
        style={{ display: 'flex', flexGrow: '1', justifyContent: 'end' }}
      >
        &nbsp;
        <a
          className="btn btn-theme-cancel btn-xs"
          data-tip="Reload Pages"
          data-place="bottom"
          data-effect="solid"
          onClick={() => {
            fetchData(projectId, version, figmaLink, setData, fetchFigmaToHtmlData);
          }}
        >
          <i className="wb webconnect-refresh"></i>
        </a>
      </span>
      <div className="row mx-auto h-70 table-responsive">
        <table className="table table-bordered table-hover table-sm table-word-break">
          <thead>
            <tr>
              <th>Frame Name</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={index}>
                  <td>{item.name}</td>
                  <td className="text-right">
                    <button
                      className="btn btn-xs btn-theme-delete"
                      style={{ cursor: true ? 'pointer' : 'not-allowed' }}
                      title={`Delete URL/Link Tag`}
                      onClick={() => {
                        handelDelete(
                          figmaLink,
                          item.id,
                          projectId,
                          version,
                          setData,
                          handelDeleteFigmaHtml,
                          deleteFigmaToHtmlData,
                        );
                      }}
                    >
                      <i className={`wb ${drapcodeIcon('delete')}`}></i>&nbsp;
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td>No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </ParentContentCard>
  );
};

export default FigmaHtmlTable;
